import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  getUserFlow,
  updateUserFlow,
  getPurlContactGroup,
} from "../../service/api";
import { Roles, PermissionFields } from "./userFlowConfig";
import "./userFlowJourney.css";
import { Breadcrumb } from "react-bootstrap";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const UserFlowJourney = () => {
  const [contactGroupLoader, setContactGroupLoader] = useState(false);
  const [contactOptions, setContactOptions] = useState([]);
  const [selectedContactGroup, setSelectedContactGroup] = useState(null);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const fetchContactGroups = async () => {
      setContactGroupLoader(true);
      try {
        const response = await getPurlContactGroup();
        const options = response?.data?.contactGroup?.map((group) => ({
          value: group,
          label: group,
        }));
        setContactOptions(options);
      } catch (err) {
        console.error(err);
      }
      setContactGroupLoader(false);
    };
    fetchContactGroups();
  }, []);

  useEffect(() => {
    if (!selectedContactGroup) return;

    const fetchUserFlow = async () => {
      try {
        const response = await getUserFlow(selectedContactGroup.value);
        const rolePermissions = response.data.data?.flow?.rolePermissions || {};
        setPermissions(rolePermissions);
      } catch (err) {
        console.error(err);
        setPermissions({});
      }
    };

    fetchUserFlow();
  }, [selectedContactGroup]);

  const handlePermissionChange = async (role, fieldKey) => {
    if (!selectedContactGroup) return;

    const previousPermissions = permissions[role]?.[fieldKey];

    const updatedFieldPermission = !previousPermissions;

    setPermissions((prevPermissions) => ({
      ...prevPermissions,
      [role]: {
        ...prevPermissions[role],
        [fieldKey]: updatedFieldPermission,
      },
    }));

    try {
      await updateUserFlow({
        contactGroup: selectedContactGroup.value,
        role: role,
        permissions: { [fieldKey]: updatedFieldPermission },
      });
    } catch (err) {
      console.error(err);
      // Revert the state if an error occurs
      setPermissions((prevPermissions) => ({
        ...prevPermissions,
        [role]: {
          ...prevPermissions[role],
          [fieldKey]: previousPermissions,
        },
      }));
    }
  };

  return (
    <>
      <div className="user-flow-container">
        <div className="header">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{
              className: "breadcrumb-dark breadcrumb-transparent",
            }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>User Flow Journey</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="contact-group-container">
          <h2 className="heading">User Flow Journey</h2>
          <Select
            isLoading={contactGroupLoader}
            value={selectedContactGroup}
            onChange={setSelectedContactGroup}
            options={contactOptions}
            placeholder="Contact Group"
            className="contact-group-select"
          />
        </div>
        <table
          className={`permissions-table ${
            !selectedContactGroup ? "disabled" : ""
          }`}
        >
          <thead>
            <tr>
              <th>PERMISSIONS</th>
              {Object.values(Roles).map((role) => (
                <th key={role}>{role}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {PermissionFields.map((field) => (
              <tr key={field.key}>
                <td>{field.label}</td>
                {Object.values(Roles).map((role) => (
                  <td key={role}>
                    <input
                      type="checkbox"
                      checked={permissions[role]?.[field.key] || false}
                      onChange={() => handlePermissionChange(role, field.key)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
